if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        // Varyant inputunu güvenli şekilde seç
        this.variantIdInput = this.form.querySelector('[name=id]');
        if(this.variantIdInput) this.variantIdInput.disabled = false;

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        
        // Sepet Çekmecesi veya Bildirim Elementini Bul
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        
        this.submitButton = this.querySelector('[type="submit"]');
        if (this.submitButton) {
            this.submitButtonText = this.submitButton.querySelector('span') || this.submitButton;
            // Eğer çekmece varsa, butona dialog özelliği ata
            if (document.querySelector('cart-drawer')) {
                this.submitButton.setAttribute('aria-haspopup', 'dialog');
            }
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        
        // --- ATLAS FIX: AKILLI ÇAKIŞMA YÖNETİMİ ---
        // 1. Eğer bu form bir "Quick Add Modal" içindeyse: Olayı durdurma! (Modalın çalışmasına izin ver)
        // 2. Eğer normal sayfadaysa veya slider içindeyse: Olayı durdur (Slider'ın çift eklemesini engelle)
        
        const isQuickAdd = this.closest('quick-add-modal');
        
        if (!isQuickAdd) {
            if (evt.stopImmediatePropagation) {
                evt.stopImmediatePropagation();
            } else {
                evt.stopPropagation();
            }
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // Butonu Kilitle ve Loading Göster
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        // Fetch Ayarları
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        
        // Sepet Çekmecesine "Bana şu bölümlerin güncel HTML'ini gönder" diyoruz
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        // --- FETCH İŞLEMİ ---
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // --- HATA DURUMU (Stok Bitti vb.) ---
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              if(this.submitButtonText) this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              // Eğer sayfada sepet çekmecesi yoksa, direkt sepet sayfasına git
              window.location = window.routes.cart_url;
              return;
            }

            // --- BAŞARILI DURUM ---
            if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cartData: response });
            
            this.error = false;

            // 1. Sepet Çekmecesini Güncelle (Resmi Yöntem)
            if (this.cart && this.cart.renderContents) {
                this.cart.renderContents(response);
            }

            // 2. ATLAS GÜVENCESİ: Header'daki İkonu (Bubble) Manuel Güncelle
            // (Bazı temalarda section rendering gecikebilir, bu kod garantiye alır)
            fetch('/cart.js')
            .then(r => r.json())
            .then(cart => {
                const bubbles = document.querySelectorAll('.cart-count-bubble, #CartCount, .cart-count, .header__cart-count');
                bubbles.forEach(el => { 
                   // İçinde span varsa ona yaz, yoksa direkt elemente yaz
                   const span = el.querySelector('span[aria-hidden="true"]') || el;
                   span.innerText = cart.item_count;
                   el.classList.remove('hidden'); 
                   el.style.visibility = 'visible';
                });
            });

            // 3. Eğer Hızlı Ekle Modalıysa, Modalı Kapat
            if (isQuickAdd) {
               const modal = this.closest('quick-add-modal');
               if(modal) {
                 // Çekmece açılacağı için modalı kapatıyoruz (UX iyileştirmesi)
                 modal.hide(true); 
               }
            }

          })
          .catch((e) => {
            console.error('Atlas Cart Error:', e);
          })
          .finally(() => {
            // İşlem bitince buton kilidini aç
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            
            const spinner = this.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if(this.submitButtonText) this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }
    }
  );
}